export default "__VITE_ASSET__Dfx1NV8w__"